import { envConfig } from "@/config";
import { posthog } from "posthog-js";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const initPostHog = (username: string, email: string, applianceId: string, applianceName: string): void => {
	if (!posthog.__loaded) {
		posthog.init(envConfig.POSTHOG_KEY || "", {
			api_host: envConfig.POSTHOG_HOST || "https://app.posthog.com",
			autocapture: true, // Enable automatic event tracking
			capture_pageview: false, // Set to false to manually track page views
			capture_performance: true, // Enable performance tracking
			disable_session_recording: false, // Enable session recording
			session_recording: {
				recordCrossOriginIframes: true,
				maskAllInputs: false,
				maskInputOptions: {
					password: true,
				},
			},
			session_idle_timeout_seconds: 28800, // Session timeout set to 8 hrs
		});
	}

	if (username && applianceId) {
		const postHogUserIdentifier = username + " + " + applianceId;
		posthog.identify(postHogUserIdentifier, {
			username,
			email,
			applianceId,
			applianceName,
		});
	}
};

export const usePosthogRouteChangeListener = (): void => {
	const location = useLocation();

	useEffect(() => {
		// Capture pageview event on route change
		posthog.capture("$pageview", { url: location.pathname });
	}, [location]);
};

export const resetPosthog = (): void => {
	posthog.reset();
};
